import React, { ReactNode } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { GavelOutlined } from '@mui/icons-material';

interface Props {
  isVisible: boolean;
  message: string | ReactNode;
  onConfirm?: () => void;
  onClose?: () => void;
}

const InvestigationDialog: React.FC<Props> = (props: Props) => {
  return (
    <Dialog open={props.isVisible} onClose={props.onClose}>
      <DialogTitle className="text-xl text-neutral-600 !font-bold">Utredning</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.message}</DialogContentText>
      </DialogContent>
      <DialogActions className="!px-[20px] !py-[24px] !justify-between">
        <Button className="w-52 h-13" variant="outlined" color="error" onClick={props.onClose}>
          Avbryt
        </Button>
        <Button
          className="w-52 h-13"
          variant="contained"
          color="error"
          endIcon={<GavelOutlined />}
          onClick={props.onConfirm}
        >
          Begär utredning
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvestigationDialog;
